import { RedesignLayout, NotificationBanner } from '../shared';
import { useHomePage } from './hooks/useHomePage';
import HomePageEvolutionToolsSection from './components/HomePageEvolutionToolsSection';
import HomePageHero from './components/HomePageHero';
import HomePageInnovativeToolsSection from './components/HomePageInnovativeToolsSection';
import HomePageOverlays from './components/HomePageOverlays';
import HomePageUniversSection from './components/HomePageUniversSection';
import locale from './locale.json';
import { useHomePageStyles } from './index.styles';

const HomePage = () => {
  const classes = useHomePageStyles();
  const homePageState = useHomePage();
  const showEbookBanner = Boolean(homePageState.hasCandidature && homePageState.idEbook);

  return (
    <RedesignLayout footer={true} noPadding={true}>
      <div className={classes.page}>
        {showEbookBanner && (
          <NotificationBanner
            label={locale.ebookBannerLabel}
            actionLabel={locale.ebookBannerCta}
            onClick={homePageState.goToEbookRecrutement}
          />
        )}

        <HomePageHero state={homePageState} />

        <HomePageUniversSection onNavigate={homePageState.redirect} />

        <HomePageEvolutionToolsSection
          resourceCounts={homePageState.resourceCounts}
          onNavigate={homePageState.redirect}
        />

        <HomePageInnovativeToolsSection state={homePageState} />
      </div>

      <HomePageOverlays state={homePageState} />
    </RedesignLayout>
  );
};

export default HomePage;
export { default as HomePageOverlays } from './components/HomePageOverlays';
export { useHomePage } from './hooks/useHomePage';
